// design-v2:Registry 是 apps.yaml 的前端化身。
// 条目顺序 = 桌面顺序 = 开始菜单顺序(直接来自 yaml 数组),不再有 desktopIconOrder
// / startMenuOrder / sort / visible 等配置字段——想隐藏就在 yaml 里注释掉。
import { createContext, useContext } from 'react';
import type { ComponentType } from 'react';
import type { IconSource, Permission } from '@blade/os-sdk';

export interface RegistryEntry {
  id: string;
  title: string;
  icon: IconSource;
  installed?: boolean;
  publisher?: string;
  /** 对应的 managed service 当前不是 running,桌面图标要变暗展示。 */
  disabled?: boolean;
  /** 经应用市场安装(区别于自己部署的应用)——桌面「自有应用」角标不能打这个。 */
  marketInstalled?: boolean;
  singleton?: boolean;
  defaultSize?: { width: number; height: number };
  // 懒加载入口。注册表本身不主动拉组件代码;
  // launchApp 会在首次启动时再把它包进 React.lazy。
  load?: () => Promise<ComponentType<unknown>>;
  externalUrl?: string;
  openIn?: 'newTab' | 'sameTab' | 'window';
  permissions: readonly Permission[];
}

export interface Registry {
  entries: RegistryEntry[];
  get: (appId: string) => RegistryEntry | undefined;
}

export const RegistryContext = createContext<Registry | null>(null);

export function useRegistry(): Registry {
  const ctx = useContext(RegistryContext);
  if (!ctx) {
    throw new Error('RegistryContext not provided');
  }
  return ctx;
}
